import React, { lazy } from "react";
import {
    Navigate,
} from "react-router-dom";


const BackupListComponent = lazy(() => import("../../../../../components/backup/components/list/page"));

export const backupsRoute = [
    {
        path: 'list',
        element: <BackupListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/options/backups/list" />
    },
];